"use client";

import { PhoneLayout } from "@/features/previews/layouts/PhoneLayout";
import { useWebsiteData } from "./hooks";
import type { QRProps } from "@/contexts/QREditorContext/types";
import { WebsiteSocialSection } from "./components/WebsiteSocialSection";

import { PreviewHeroHeader, PreviewPrimaryAction } from "@/features/previews/shared/components";

import "./WebsiteTemplate.scss";

export const WebsiteTemplate = (props: QRProps<"website">) => {
  const { isInitialPreview, data } = useWebsiteData(props);

  if (!data) {
    return null;
  }

  const { companyName, logoUrl, title, subtitle, buttonText, buttonUrl, themeColor } = data;

  return (
    <PhoneLayout
      page="website"
      dataQA="preview-website-container"
      backgroundColor={themeColor?.backgroundColor || "white"}
      isInitPreview={isInitialPreview}
      hasIncludeBrowser
    >
      <div className="website-template">
        <PreviewHeroHeader
          variant="website"
          companyName={companyName}
          logoUrl={logoUrl}
          title={title}
          subtitle={subtitle}
          isInitialPreview={isInitialPreview}
          logoAlt="Company logo"
        >
          {buttonText && (
            <div className="website-template__primary-button">
              <PreviewPrimaryAction
                text={buttonText}
                url={buttonUrl}
                buttonColor={themeColor?.buttonColor}
                className="u-spacing-5 website-button"
              />
            </div>
          )}

          <WebsiteSocialSection
            data={data}
            isInitialPreview={isInitialPreview}
          />
        </PreviewHeroHeader>
      </div>
    </PhoneLayout>
  );
};
